(function ($) {

    'use strict';
  
    theme.customerLogin = function () {
      // 检查url是否是invalid token页面，如果是就跳转到忘记密码页面
      checkInvalidToken();
      function checkInvalidToken() {
        if (location.href.indexOf('invalid_token') > 0) {
          window.history.replaceState(null, null, '/account/login');  // 替换地址栏
          $('#form-container .tt-form-error').html('');
          $('.form-container').hide();
          $('.forget-password-form-container').show();
        }
        // /account/login/#recover   直接显示忘记密码界面
        if (location.href.indexOf('#recover') > 0) {
          $('.form-container').hide();
          $('.forget-password-form-container').show();
        }
      }
      
      const query = __MakeBlock_Utils.getQueryParams()
      $('.form-container').hide();
      $('.forget-password-form-container').hide();
      if (query.active === 'forgetPassword') {
        $('.forget-password-form-container').show();
      } else {
        $('.form-container').show();
      }
      // 忘记密码、返回按钮事件
      $('#forgetpass').click(function () {
        $('.form-container').hide();
        $('.forget-password-form-container').show();
      });
      $('#backto-signin').click(function () {
        $('.form-container').show();
        $('.forget-password-form-container').hide();
      });
  
      /*****************登录模块*****************/
      const $loginForm = $("#customer_login"),
        $errorContainer = $(".form-error")
      // 点击提交按钮
      $('#login-btn').click(function (event) {
        event.preventDefault()
        // 验证表单
        if (!validForm()) {
          return
        }
        $('#loading').show();  // 展示菊花
        $('#btn-text').text('Signing'); // 登录中
        const emailNode = document.querySelector('#email');
        if (emailNode) {
          const email = emailNode.value;
          const LOGIN_EMAIL = 'LOGIN_EMAIL';
          // 设置登录成功 cookie 2min失效（临时解决办法）
          __MakeBlock_Utils.setCookie(LOGIN_EMAIL, email, 2 * 60);
        }
        $loginForm.submit()
      })
  
      // 切换密码框类型
      togglePasswordType();
      function togglePasswordType() {
        const eyeUrl = 'https://cdn.shopify.com/s/files/1/0467/7985/9095/files/eye.png?v=1667787059',
          noEyeUrl = 'https://cdn.shopify.com/s/files/1/0467/7985/9095/files/no-eye.png?v=1667787060';
        const needToggleEles = [$('#toggleEye')];
        needToggleEles.map(function ($toggleEye) {
          $toggleEye.click(function () {
            const $prev = $toggleEye.prev();
            if ($prev.attr('type') == 'password') {
              $prev.attr('type', 'text');
              $toggleEye.attr('src', eyeUrl);
            } else {
              $prev.attr('type', 'password');
              $toggleEye.attr('src', noEyeUrl);
            }
          })
        })
      }
  
    //验证表单
    function validForm() {
      const data = getFormData($loginForm);
      // 验证email
      if (!data['customer[email]']) {
        $errorContainer.html("Email can't be blank.")
        return false
      }
      // 验证邮箱是否合法
      if (data['customer[email]'] && !checkEmail(data['customer[email]'])) {
        $errorContainer.html("Email is invalid.")
        return false
      }
      // 验证密码
      if (!data['customer[password]']) {
        $errorContainer.html("Password can't be blank.")
        return false
      }
      // 验证密码长度
      if (data['customer[password]'] && data['customer[password]'].length < 5) {
        $errorContainer.html("Password is too short (minimum is 5 characters).")
        return false
      }
      // 验证密码长度
      if (data['customer[password]'] && data['customer[password]'].length > 20) {
        $errorContainer.html("Password is too long (maximum is 20 characters).")
        return false
      }
      $errorContainer.html('');
      return true
    }
  
      // 验证邮箱
      function checkEmail(value) {
        var pattern = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        return pattern.test(value);
      }
  
      // 获取表单数据
      function getFormData($form) {
        let data = {};
        let arr = $form.serializeArray();
        arr.map(function (item) {
          data[item.name] = item.value;
        })
        return data;
      }
  
      /*****************忘记密码模块*****************/
      const $forgetErrorContainer = $(".forget-form-error")
      // 点击提交按钮
      $('#forget-btn').click(function (event) {
        event.preventDefault();
        const email = $("#forget-email").val();
        // 验证表单
        if (!validForgetForm(email)) {
          return
        }
        // 发送邮件
        sendEmail(email)
      })
  
      //验证表单
      function validForgetForm(email) {
        // 验证email
        if (!email) {
          $forgetErrorContainer.html("Email can't be blank.")
          return false
        }
        // 验证邮箱是否合法
        if (email && !checkEmail(email)) {
          $forgetErrorContainer.html("Email is invalid.")
          return false
        }
        $forgetErrorContainer.html('');
        return true
      }
  
      // 发送email
      function sendEmail(email) {
        const formData = new FormData();
        formData.append('form_type', 'recover_customer_password');
        formData.append('utf8', '✓');
        formData.append('email', email);
        $('#forget-loading').show();  // 展示菊花
        $('#forget-btn-text').text('Sending'); // 发送中
  
        fetch('/account/recover', { method: 'POST',body: formData })
          .then(function (response) {
            var $errorEle = $(response).find('#forget-password-error-tips .errors');
            var logErrors = $errorEle.text();
            var html = $errorEle.html();
            if (!logErrors) {
              $forgetErrorContainer.addClass('success').html(`We have sent you a password reset email. Please check and reset the password.`)
            } else {
              if (html.indexOf('No account found with that email.')) {
                $forgetErrorContainer.removeClass('success').html('There is no account related with this email.')
              } else {
                $forgetErrorContainer.removeClass('success').html(logErrors);
              }
            }
            $('#forget-loading').hide();  // 隐藏菊花
            $('#forget-btn-text').text('Send Email'); // 发送邮件
          }).
          catch(function () {
            $forgetErrorContainer.removeClass('success').html('The sending frequency is too fast, please try again later');
            $('#forget-loading').hide();  // 隐藏菊花
            $('#forget-btn-text').text('Send Email'); // 发送邮件
          })
      }
  
    };
  
    theme.AssetsLoader.onPageLoaded(function () {
      theme.customerLogin();
    });
  })(jQueryTheme);